import { Box, Stack, Tooltip, Typography } from '@mui/material';
import { formatAmount } from 'utils/helpers';
import Avatar from 'components/Common/Avatar';
import GenerateQRCode from 'pages/QR/GenerateQRCode';
import { Basket } from 'types/common';

interface BasketProfileTypes {
    basket: Basket | null;
}

function BasketProfile({ basket }: BasketProfileTypes) {
    const { imgUrl, name, balance } = basket || {};
    return (
        <Stack direction="row" alignItems="center" sx={{ width: '23rem', height: 124, backgroundColor: 'white', borderRadius: 1, pl: 1 }}>
            <Box style={{ marginRight: 4 }}>
                <Avatar name={name || ''} url={imgUrl} avatarProps={{ sx: { width: 76, height: 76, fontSize: 24 }, variant: 'square' }} />
            </Box>
            <Stack ml={1} flexGrow={1}>
                <Tooltip title={name}>
                    <Typography className="two-line-text" variant="h4" sx={{ fontSize: 22, fontWeight: 400 }}>
                        {name}
                    </Typography>
                </Tooltip>
                <Typography fontSize={22} fontWeight={400}>
                    {formatAmount(balance || '')}
                </Typography>
                {/* <Typography style={{ fontSize: 12, color: '#1F2937', fontWeight: 300 }}>Auto clear on mm/dd/yyyy mm:hh</Typography> */}
            </Stack>
            {basket?.id && <GenerateQRCode basket={basket} />}
        </Stack>
    );
}

export default BasketProfile;
